const isFileImage = file => {
  const acceptedImageTypes = ['image/gif', 'image/jpeg', 'image/png', 'image/svg+xml', 'image/bmp', 'image/tiff', 'image/webp'];

  return file && acceptedImageTypes.includes(file.type);
};

export default isFileImage;
